var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "Tabs",
        [
          _c(
            "Tab",
            { attrs: { name: "Telco", selected: "true" } },
            [
              _c("TelcoFormGeneral", {
                attrs: {
                  modoVer: true,
                  telcoid: _vm.telcoid,
                  telconame: _vm.telconame,
                  telcoprefix: _vm.telcoprefix,
                  estadoSelected: _vm.estadoSelected,
                  usuarioID: _vm.usuarioID
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Planes Telco" } },
            [
              _c("TelcoFormPlanes", {
                attrs: { modoVer: true, telcoid: _vm.telcoid }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Apn" } },
            [
              _c("TelcoFormApn", {
                attrs: { modoVer: true, telcoid: _vm.telcoid }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Stock Crítico" } },
            [
              _c("TelcoFormStock", {
                attrs: { modoVer: true, telcoid: _vm.telcoid }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }